<div class="d-flex justify-content-center align-items-center" style="height: 100%">
  <span>{{ status }}</span>
</div>
